module.exports = __webpack_public_path__ + "static/media/fa-regular-400.8d9ab84b.woff2";